export const 개인사업자고액환급액기준금액 = 3000000;

export const 법인사업자고액환급액기준금액 = 20000000;
